import css from "../../css/listing/property-active.module.css";
import cssBasic from "../../css/listing/property-active-basic-info.module.css";

import React from "react";
import PropTypes from "prop-types";
import ToastNotification from "../ToastNotification";
import isRent from "../../helper/isRent";
import moneyFormatter from "../../helper/moneyFormatter";
import Badge from "./Badge";
import PropertyBasicInfo from "./PropertyBasicInfo";
import PropertyButtons from "./PropertyButtons";

const PropertyActive = (props) => {
    const { listing } = props;

    const { badge } = listing;
    const rent = isRent(listing);
    let price = "";
    let priceLabel = "";

    if (listing.price && listing.price > 0) {
        if (rent) {
            priceLabel = "For Rent";
            price = (
                <span className={css.price}>
                    {moneyFormatter(0).format(listing.price)}
                    <span className={css.priceMo}>/mo</span>
                </span>
            );
        } else {
            priceLabel = "Asking";
            price = (
                <span className={css.price}>
                    {moneyFormatter(0).format(listing.price)}
                </span>
            );
        }
    } else {
        price = "Price available on request";
    }

    return (
        <div className={css.properties}>
            <ToastNotification />
            <div className={css.firstLine}>
                <PropertyBasicInfo listing={listing} css={cssBasic} />
                <div className={css.priceContainer}>
                    {priceLabel} &nbsp;
                    {price}
                </div>
            </div>
            <div className={css.secondLine}>
                {badge && (
                    <div className={css.badge}>
                        <Badge color={badge.color} label={badge.label} />
                    </div>
                )}
                <PropertyButtons listing={listing} />
            </div>
        </div>
    );
};

PropertyActive.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default PropertyActive;
